import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface GetApiRoutesState {
    loading: boolean;
    loadingError: boolean;
    routes: any;
}

const initialState: GetApiRoutesState = {
    loading: false,
    loadingError: false,
    routes: null,
};

const getApiRoutesSlice = createSlice({
    name: 'getApiRoutes',
    initialState,
    reducers: {
        fetchGetRoutes(state: GetApiRoutesState, action: PayloadAction<{}>) {
            state.loading = true;
            state.loadingError = false;
        },
        fetchGetRoutesSuccess(state: GetApiRoutesState, action: any) {
            state.routes = action.payload;
            state.loading = false;
        },
        fetchGetRoutesFailed(state: GetApiRoutesState) {
            state.loading = false;
            state.loadingError = true;
        },
    },
});

// Actions
export const apiRoutesActions = getApiRoutesSlice.actions;
// Selectors
export const routeLoading = (state: { getApiRoutes: GetApiRoutesState }): boolean => state.getApiRoutes.loading;
export const routeLoadingError = (state: { getApiRoutes: GetApiRoutesState }): boolean => state.getApiRoutes.loadingError;
export const routes = (state: { getApiRoutes: GetApiRoutesState }): any => state.getApiRoutes.routes;

// Reducers
const getApiRoutesReducer = getApiRoutesSlice.reducer;
export default getApiRoutesReducer;